<template>
  <div :callCount="item.callCount" class="ticket" :class="{'ticket_blink': hasBlink, 'ticket_compact':compact, 'ticket-with-name': item.name }">
    <div class="ticket__wrapper">
      <div class="ticket__number">
        {{ item.ticketNumber }}
        <div class="ticket__arrow">
          <IconArrowRight/>
        </div>
      </div>
      <div class="ticket__window">{{ item.seatLabel }}</div>
      <div class="ticket__state"> {{ item.title }}</div>
    </div>
    <div class="ticket__name" v-if="item.name">{{ $t('common.client') }}: {{ item.name }}</div>
  </div>
</template>

<script>
  // components
  import IconArrowRight from '@/components/Icons/IconArrowRight'
  import { mapState } from 'vuex'

  export default {
    name: 'Ticket',
    components: {
      IconArrowRight
    },
    props: {
      compact: {
        type: Boolean,
        required: false
      },
      item: {
        type: Object,
        required: false
      },
      visible: {
        required: false
      }
    },
    computed: {
      ...mapState({
        playListSpeakId: state => state.playlist.speakId
      }),
      hasBlink () {
        return this.playListSpeakId === this.item.id
      }
    },
    data () {
      return {
        blink: false
      }
    }
  }
</script>
